import { render, staticRenderFns } from "./PageEducatorInstitutionApplicationCancel.vue?vue&type=template&id=d8d53288&scoped=true&"
import script from "./PageEducatorInstitutionApplicationCancel.vue?vue&type=script&lang=js&"
export * from "./PageEducatorInstitutionApplicationCancel.vue?vue&type=script&lang=js&"
import style0 from "./PageEducatorInstitutionApplicationCancel.vue?vue&type=style&index=0&id=d8d53288&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8d53288",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VAlert,VBtn,VCard,VCardTitle,VCol,VContainer,VRow})
